const getUserAgent = () => {
  const userAgent = window.navigator.userAgent;
  return userAgent;
};

export default getUserAgent;
